import React from "react";
import useMedia from "use-media";
import {
  Wrapper,
  ContainerAzul,
  ContainerElementos,
  TextoPequeno,
  TextoMedio,
  ContainerRedesSociaisFooter,
  SpacerEntreBlocos,
  ImgFooterDog,
  ImgGooglePlay,
  ImgAppStore,
  ContainerUmaMarcaFooter,
  ContainerDireitosFooter,
  ImgSimplifique,
  ImgSelo,
  ContainerMobileStores,
  TextoLegalInfo,
  Row,
  Column,
} from "./styles";

import CustomLink from "../CustomLink";
import { InnerContainer } from "../../layouts/Default";
import { BlocoMedia } from "../Footer/styles";

export default () => {
  const isMobile = useMedia({ maxWidth: 767 });
  return (
    <Wrapper>
      <ContainerAzul>
        <InnerContainer noOverflow={true}>
          <ContainerElementos>
            <ImgFooterDog
              src="/gwmbrasil/assets/footer/V.png"
              alt="Imagem de um V"
            />
            {isMobile ? (
              <BlocoMedia>
                <TextoMedio>Baixe o app</TextoMedio>

                <ContainerMobileStores>
                  <CustomLink
                    to="https://play.google.com/store/apps/details?id=br.com.veloe.mobile"
                    tagLabel="googleplay"
                    img
                  >
                    <ImgGooglePlay
                      src="/gwmbrasil/assets/footer/google-play.png"
                      alt="Google Play Logo"
                    />
                  </CustomLink>
                  <CustomLink
                    to="https://itunes.apple.com/us/app/veloe/id1278343398"
                    tagLabel="appstore"
                    img
                  >
                    <ImgAppStore
                      src="/gwmbrasil/assets/footer/app-store.png"
                      alt="App Store Logo"
                    />
                  </CustomLink>
                </ContainerMobileStores>

                <SpacerEntreBlocos />

                <ContainerUmaMarcaFooter>
                  <TextoPequeno>Uma marca</TextoPequeno>

                  <ImgSimplifique
                    src="/gwmbrasil/assets/footer/logo_alelo.png"
                    alt="Alelo Logo"
                    style={{ marginRight: "7px" }}
                  />
                </ContainerUmaMarcaFooter>

                <SpacerEntreBlocos />

                <TextoMedio>Redes Sociais</TextoMedio>
                <ContainerRedesSociaisFooter>
                  <CustomLink
                    to="https://www.instagram.com/veloebr/"
                    tagLabel="instagram"
                    img
                    center
                  >
                    <ImgSimplifique
                      src="/gwmbrasil/assets/footer/social_media_instagram.png"
                      alt="Instagram Logo"
                    />
                  </CustomLink>
                  <CustomLink
                    to="https://www.facebook.com/Veloebr/"
                    tagLabel="facebook"
                    img
                    center
                  >
                    <ImgSimplifique
                      src="/gwmbrasil/assets/footer/social_media_facebook.png"
                      alt="Facebook Logo"
                    />
                  </CustomLink>
                  <CustomLink
                    to="https://www.youtube.com/c/Veloe"
                    tagLabel="youtube"
                    img
                    center
                  >
                    <ImgSimplifique
                      src="/gwmbrasil/assets/footer/social_media_youtube.png"
                      alt="Youtube Logo"
                    />
                  </CustomLink>
                  <CustomLink
                    to="https://twitter.com/veloebr"
                    tagLabel="twitter"
                    img
                    center
                  >
                    <ImgSimplifique
                      src="/gwmbrasil/assets/footer/social_media_twitter.png"
                      alt="Twitter Logo"
                    />
                  </CustomLink>
                  <CustomLink
                    to="https://open.spotify.com/user/pjad7ksh9sgzgwv78gocc647r"
                    tagLabel="spotify"
                    img
                    center
                  >
                    <ImgSimplifique
                      src="/gwmbrasil/assets/footer/social_media_spotify.png"
                      alt="Spotify Logo"
                    />
                  </CustomLink>
                </ContainerRedesSociaisFooter>

                <SpacerEntreBlocos />

                <ContainerDireitosFooter>
                  <ImgSelo
                    src="/gwmbrasil/assets/footer/selo.png"
                    alt="Selo Reclame Aqui"
                  />
                  <div style={{ width: "249px" }}>
                    <TextoLegalInfo>
                      Alelo S.A <br />
                      Alameda Xingu, Barueri - SP, <br /> 06455-030
                    </TextoLegalInfo>
                    <br />
                    <TextoLegalInfo>
                      © Todos os direitos reservados - Veloe 2023 - CNPJ:
                      04.740.876/0001-25
                    </TextoLegalInfo>
                    <div style={{ marginTop: 10 }}>
                      <CustomLink
                        to="/termos-de-uso"
                        tagLabel="termos-de-uso-e-politica-de-privacidade"
                      >
                        Contrato Veloe e Política de Privacidade
                      </CustomLink>
                    </div>
                  </div>
                </ContainerDireitosFooter>
              </BlocoMedia>
            ) : (
              <Row>
                <Column>
                  <TextoMedio>Baixe o app</TextoMedio>
                  <ContainerMobileStores>
                    <CustomLink
                      to="https://play.google.com/store/apps/details?id=br.com.veloe.mobile"
                      tagLabel="googleplay"
                      img
                    >
                      <ImgGooglePlay
                        src="/gwmbrasil/assets/footer/google-play.png"
                        alt="Google Play Logo"
                      />
                    </CustomLink>
                    <CustomLink
                      to="https://itunes.apple.com/us/app/veloe/id1278343398"
                      tagLabel="appstore"
                      img
                    >
                      <ImgAppStore
                        src="/gwmbrasil/assets/footer/app-store.png"
                        alt="App Store Logo"
                      />
                    </CustomLink>
                  </ContainerMobileStores>

                  <TextoMedio>Redes Sociais</TextoMedio>
                  <ContainerRedesSociaisFooter>
                    <CustomLink
                      to="https://www.instagram.com/veloebr/"
                      tagLabel="instagram"
                      img
                      center
                    >
                      <ImgSimplifique
                        src="/gwmbrasil/assets/footer/social_media_instagram.png"
                        alt="Instagram Logo"
                      />
                    </CustomLink>
                    <CustomLink
                      to="https://www.facebook.com/Veloebr/"
                      tagLabel="facebook"
                      img
                      center
                    >
                      <ImgSimplifique
                        src="/gwmbrasil/assets/footer/social_media_facebook.png"
                        alt="Facebook Logo"
                      />
                    </CustomLink>
                    <CustomLink
                      to="https://www.youtube.com/c/Veloe"
                      tagLabel="youtube"
                      img
                      center
                    >
                      <ImgSimplifique
                        src="/gwmbrasil/assets/footer/social_media_youtube.png"
                        alt="Youtube Logo"
                      />
                    </CustomLink>
                    <CustomLink
                      to="https://twitter.com/veloebr"
                      tagLabel="twitter"
                      img
                      center
                    >
                      <ImgSimplifique
                        src="/gwmbrasil/assets/footer/social_media_twitter.png"
                        alt="Twitter Logo"
                      />
                    </CustomLink>
                    <CustomLink
                      to="https://open.spotify.com/user/pjad7ksh9sgzgwv78gocc647r"
                      tagLabel="spotify"
                      img
                      center
                    >
                      <ImgSimplifique
                        src="/gwmbrasil/assets/footer/social_media_spotify.png"
                        alt="Spotify Logo"
                      />
                    </CustomLink>
                  </ContainerRedesSociaisFooter>
                </Column>
                <Column>
                  <ContainerUmaMarcaFooter>
                    <TextoPequeno>Uma marca</TextoPequeno>

                    <ImgSimplifique
                      src="/gwmbrasil/assets/footer/logo_alelo.png"
                      alt="Alelo Logo"
                      style={{ marginRight: "7px" }}
                    />
                  </ContainerUmaMarcaFooter>

                  <ContainerDireitosFooter>
                    <ImgSelo
                      src="/gwmbrasil/assets/footer/selo.png"
                      alt="Selo Reclame Aqui"
                    />
                    <div>
                      <TextoLegalInfo>
                        Alelo S.A. Alameda Xingu, Barueri - SP, <br /> 06455-030
                      </TextoLegalInfo>
                      <br />
                      <TextoLegalInfo>
                        © Todos os direitos reservados - Veloe 2023 - <br />
                        CNPJ: 04.740.876/0001-25
                      </TextoLegalInfo>
                      <br />
                      <CustomLink
                        to="/termos-de-uso"
                        tagLabel="termos-de-uso-e-politica-de-privacidade"
                      >
                        Contrato Veloe e Política de Privacidade
                      </CustomLink>
                    </div>
                  </ContainerDireitosFooter>
                </Column>
              </Row>
            )}
          </ContainerElementos>
        </InnerContainer>
      </ContainerAzul>
    </Wrapper>
  );
};
